import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import "../index.css";
import "react-day-picker/style.css";
import DashboardLayout from "../components/layout/dashboard/layout";
import Dashboard from "../pages/Dashboard";
import Shop from "../pages/Dashboard/shop";
import Inventory from "../pages/Dashboard/inventory";
import Gallery from "../pages/Dashboard/gallery";
import Reviews from "../pages/Dashboard/reviews";
import OurStory from "../pages/Dashboard/our-story";
import Settings from "../pages/Dashboard/settings";
import BookingsPage from "../pages/Dashboard/bookings";
import { BookingDetails } from "../components/dashboard/bookings/booking-details";
import { AddBookingForm } from "../components/dashboard/bookings/add-booking-form";
import FooterEditor from "../pages/Dashboard/footerContent";
import { EditBookingForm } from "../components/dashboard/bookings/edit-booking-form";
import PrivacyPolicyEditor from "../pages/Dashboard/privacy-policy";
import BookingDuration from "../components/dashboard/bookings/booking-duration";
import { logout } from "../store/authSlice";
import Quotes from "../pages/Dashboard/quotes";
import { QuoteDetail } from "../pages/Dashboard/quotes/quote-details";
import { BookingCategory } from "../components/dashboard/bookings/booking-category";
import SchedulePage from "../pages/Dashboard/schedule";
import CustomersPage from "../pages/Dashboard/customers";

const DashboardRoutes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiry = () => {
      const tokenExpiry = localStorage.getItem("tokenExpiry");
      
      if (tokenExpiry && Date.now() > Number(tokenExpiry)) {
        dispatch(logout());
        navigate("/login"); // Redirect to login page if token expired
      }
    };

    checkTokenExpiry(); // Check on component mount
    const interval = setInterval(checkTokenExpiry, 60 * 1000); // Check every minute

    return () => clearInterval(interval); // Cleanup on unmount
  }, [dispatch, navigate]);

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />

        {/* Schedule — formerly buried in Settings → Availability, now top-level */}
        <Route path="/schedule" element={<SchedulePage />} />

        <Route path="/bookings" element={<BookingsPage />} />
        <Route path="/bookings/view/:id" element={<BookingDetails />} />
        <Route path="/bookings/edit/:id" element={<EditBookingForm />} />
        <Route path="/bookings/add" element={<AddBookingForm />} />
        {/* Services (was "Glam Packages"); old path redirected below */}
        <Route path="/services" element={<BookingCategory />} />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/quotes/:id" element={<QuoteDetail />} />

        <Route path="/customers" element={<CustomersPage />} />

        <Route path="/shop" element={<Shop />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/settings" element={<Settings />} />

        {/* ── Migration redirects (keep old bookmarks alive) ───────────── */}
        <Route path="/bookings/glam-packages" element={<Navigate to="/services" replace />} />
        <Route path="/settings/availability" element={<Navigate to="/schedule" replace />} />
        <Route path="/cms/gallery" element={<Gallery />} />
        <Route path="/cms/reviews" element={<Reviews />} />
        <Route path="/cms/our-story" element={<OurStory />} />
        <Route path="/cms/footer-content" element={<FooterEditor />} />
        <Route path="/cms/privacy-policy" element={<PrivacyPolicyEditor />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardRoutes;
